module.exports = __webpack_public_path__ + "static/media/4_avatar.8cc794db.png";